// utils/cleanHtmlContent.ts
export interface CleanHtmlOptions {
  /** Remove blocos {{ ... }} */
  removeHandlebars?: boolean
  /** Adiciona class="spaced" em <p> que começam com "1º:" / "CLAUSULA" etc */
  spaceParagraphHeads?: boolean
  /** Envolve sequências MAIÚSCULAS com <span class="highlight-uppercase"> */
  highlightUppercase?: boolean
}

const DEFAULT_OPTS: CleanHtmlOptions = {
  removeHandlebars: true,
  spaceParagraphHeads: true,
  highlightUppercase: true
}

/**
 * Limpa/estiliza um HTML conforme as regras do projeto.
 * - Remove {{ ... }}
 * - Marca <p> que começam com "nº:" ou BLOCO_EM_MAIÚSCULAS com class="spaced"
 * - Envolve sequências MAIÚSCULAS (>=2) com <span class="highlight-uppercase">, exceto dentro de <img>
 */
export function cleanHtmlContent(input: string | null | undefined, opts: CleanHtmlOptions = DEFAULT_OPTS): string {
  if (!input) return ''

  let out = String(input)

  if (opts.removeHandlebars) {
    // remove qualquer bloco {{ ... }} (inclusive quebras de linha)
    out = out.replace(/\{\{[\s\S]*?\}\}/g, '')
  }

  if (opts.spaceParagraphHeads) {
    // <p> ... "1º:" OU PALAVRA/EXPRESSÃO EM MAIÚSCULAS/ACENTOS/_
    out = out.replace(/<p>\s*(\d+º:|[A-ZÀ-Ÿ_]+)\b/g, '<p class="spaced">$1')
  }

  if (opts.highlightUppercase) {
    // envolve SEQUÊNCIAS MAIÚSCULAS (>=2) com <span> — ignora <img>
    out = out.replace(
      /<([^>]+)>([^<]*?)([A-ZÀ-Ÿ_]{2,})([^<]*?)<\/\1>/g,
      (match, tag: string, before: string, uppercase: string, after: string) =>
        tag.toLowerCase() === 'img'
          ? match
          : `<${tag}>${before}<span class="highlight-uppercase">${uppercase}</span>${after}</${tag}>`
    )
  }

  return out
}
